import React, { useRef, useState } from "react";
import { PlayCircle, ExternalLink } from "lucide-react";

// Owner-approved 55-second demo. The MP4 is served unchanged from /media (durable public asset). Native controls, no autoplay.
export const DEMO_VIDEO_SRC = "/media/siblingo-seven-children-demo.mp4";
export const DEMO_VIDEO_POSTER = "/media/siblingo-seven-children-demo-poster.jpg";

export function DemoVideo() {
  const ref = useRef(null);
  const [duration, setDuration] = useState(null);
  return (
    <section className="rounded-[2rem] border border-line bg-white p-4 sm:p-6 shadow-soft" data-testid="demo-video-section">
      <div className="flex flex-wrap items-end justify-between gap-2 px-1">
        <div>
          <p className="text-xs font-bold uppercase tracking-wide text-brand">Demo</p>
          <h2 className="mt-1 font-heading font-black text-2xl sm:text-3xl text-ink leading-tight" data-testid="demo-video-heading">Watch Siblingo in 55 seconds</h2>
        </div>
        <a href={DEMO_VIDEO_SRC} target="_blank" rel="noopener noreferrer" data-testid="demo-video-open-link" className="inline-flex items-center gap-1.5 min-h-[44px] px-4 rounded-full border border-line bg-white text-sm font-bold text-ink-soft hover:border-brand/40 hover:text-brand transition-colors">
          <ExternalLink size={14} /> Open video
        </a>
      </div>
      <div className="mt-4 rounded-3xl overflow-hidden bg-ink aspect-video">
        <video
          ref={ref}
          data-testid="demo-video"
          className="w-full h-full object-contain bg-ink"
          controls
          playsInline
          preload="metadata"
          poster={DEMO_VIDEO_POSTER}
          onLoadedMetadata={(e) => setDuration(Math.round(e.currentTarget.duration))}
        >
          <source src={DEMO_VIDEO_SRC} type="video/mp4" />
          Your browser can't play this video. <a href={DEMO_VIDEO_SRC}>Open the video</a> instead.
        </video>
      </div>
      <p className="mt-3 px-1 text-xs text-ink-muted flex items-center gap-1.5" data-testid="demo-video-meta">
        <PlayCircle size={14} className="text-brand" /> {duration ? `${duration} sec` : "55 sec"} · sound on · seven children, five looks, one $500 budget
      </p>
    </section>
  );
}
